import React, { useState, useEffect, useRef } from 'react';
import { FaBell } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import '../styles/NotificationBell.css';

const NotificationBell = () => {
    const [notifications, setNotifications] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);
    const navigate = useNavigate();

    const handleNotifClick = (notif) => {
        if (notif.action_url) {
            navigate(notif.action_url);
            setIsOpen(false);
        }
    };

    const fetchNotifications = async () => {
        try {
            const response = await api.get('/notifications');
            setNotifications(response.data.notifications);
            setUnreadCount(response.data.unreadCount);
        } catch (error) {
            console.error('Error fetching notifications:', error);
        }
    };

    useEffect(() => {
        fetchNotifications();
        // Poll every 60 seconds
        const interval = setInterval(fetchNotifications, 60000);
        return () => clearInterval(interval);
    }, []);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handleToggle = () => {
        setIsOpen(!isOpen);
        if (!isOpen && unreadCount > 0) {
            markAsRead();
        }
    };

    const markAsRead = async () => {
        try {
            await api.put('/notifications/read');
            setUnreadCount(0);
        } catch (error) {
            console.error('Error marking notifications as read:', error);
        }
    };

    return (
        <div className="notification-bell-container" ref={dropdownRef}>
            <button className="bell-btn" onClick={handleToggle}>
                <FaBell className="bell-icon" />
                {unreadCount > 0 && <span className="badge">{unreadCount}</span>}
            </button>

            {isOpen && (
                <div className="notification-dropdown">
                    <div className="dropdown-header">
                        <h3>الإشعارات</h3>
                    </div>
                    <div className="notification-list">
                        {notifications.length > 0 ? (
                            notifications.map((notif) => (
                                <div 
                                    key={notif.id} 
                                    className={`notification-item ${!notif.is_read ? 'unread' : ''}`}
                                    onClick={() => handleNotifClick(notif)}
                                    style={{ cursor: notif.action_url ? 'pointer' : 'default' }}
                                >
                                    <div className={`notification-icon ${notif.type}`}>
                                        {notif.type === 'success' && '🎉'}
                                        {notif.type === 'warning' && '⚠️'}
                                        {notif.type === 'info' && 'ℹ️'}
                                        {notif.type === 'error' && '❌'}
                                    </div>
                                    <div className="notification-content">
                                        <h4>{notif.title}</h4>
                                        <p>{notif.message || notif.body}</p>
                                        <span className="time">{new Date(notif.created_at).toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' })}</span>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no-notifications">لا توجد إشعارات جديدة</p>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default NotificationBell;
